<template>
  <v-container>
    <v-img
      :src="winLockup"
      contain
    ></v-img>
    <h1 class="white-text text-center">Plus, you have still been entered into the final draw for a chance to WIN a FESTIVE family trip to LAPLAND.</h1>
    <h2 class="white-text text-center">Please allow 28 days from the promotion close date of 30th October for them to arrive.</h2>
    <h2 class="white-text text-center">Good Luck!</h2>
    <v-img
      :src="packShot"
      contain
      class="packshot-footer no-margin"
    ></v-img>
       
  </v-container>
</template>

<script>
export default {
  data: () => ({
    winLockup : {src:require('../assets/winner-lockup.png')},
    packShot : {src:require('../assets/Packshots.png')}
  }),
};
</script>
